<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>

    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Create A New Skid/ Group</p>
          <button
            class="delete"
            aria-label="close"
            @click="close()">
          </button>
        </header>

        <div class="columns modal-card-body">
          <div class="column" v-if="!showFilters || showFilters.includes('project_id')">
            <label class="label">Search by Project</label>
            <search-autocomplete 
              :value="filters.project_id"
              @input="changeFilter('project_id', $event)"
              @updateProject="setProject($event)"/>
          </div>
          <div class="column" v-if="!showFilters || showFilters.includes('piece_no')">
            <label class="label">Search by Skid/Group #</label>
            <v-search 
              :value="filters.skid_no"
              :search-input.sync="filters.skid_no"
              @search="changeFilter('skid_no', $event)"
              @clear="changeFilter('skid_no', null)"
              placeholder="Search by Skid/Group #"/>
          </div>
          <div class="column" v-if="!showFilters || showFilters.includes('piece_no')">
            <label class="label">Search by Piece #</label>
            <v-search 
              :value="filters.piece_no"
              :search-input.sync="filters.piece_no"
              @search="changeFilter('piece_no', $event)"
              @clear="changeFilter('piece_no', null)"
              placeholder="Search by Piece #"/>
          </div>
          <div v-if="!showFilters || showFilters.includes('is_sent')">
            <label class="label">Filter by Sent/ Unsent Skids</label>
            <v-switcher 
              class="mx-2"
              :value="filters.is_sent"
              @input="changeFilter('is_sent', $event)"
              label="Only Sent Skids"/>
          </div>
        </div>

        <footer class="modal-card-foot">
          <button class="button" @click="close()">
            Done
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import VSearch from '@/components/base/VSearch'
import VSwitcher from '@/components/base/VSwitcher'
import SearchAutocomplete from '@/components/projects/SearchAutocomplete'
import { mapState, mapMutations } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    showFilters: {
      type: Array
    }
  },
  components: { SearchAutocomplete, VSearch, VSwitcher },
  computed: {
    ...mapState("skidInstallations", ["filters"])
  },
  methods: {
    ...mapMutations("skidInstallations", ["setFilter", "setProject"]),
    changeFilter(field, value) {
      this.setFilter({ field: field, value: value });
      let query = Object.assign({}, this.$route.query);
      if (value) {  
        query[field] = value;
        this.$router.push({ name: 'SkidList', query: query })
      } else {
        delete query[field];
        this.$router.push({ name: 'SkidList', query: query })
      }
    },
    close() {
      this.$emit('input', false);
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/responsive.scss';
</style>